export default __webpack_public_path__ + "static/media/claimslink-favicon.3023228c.ico";